import { titleFont, color, textSize } from '@portal/kit/pkg/styles'

const loginStyles = {
  title: {
    ...titleFont(),
    ...textSize(16, 19),
    marginBottom: 15,
    marginTop: 6,
  },
  loginButtons: {
    display: 'flex',
    width: '100%',
    paddingBottom: 12,
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  rememberMe: {
    height: 18, // forces ignoring margin bottom im
  },
  passwordRecovery: {
    textAlign: 'center',
  },
  passwordRecoveryLink: {
    ...textSize(13, 19),
    ...color('textSecondary'),

    '&:hover': {
      textDecoration: 'underline',
    },
  }
}

export default loginStyles
